import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Loader from 'iqvia-shared/components/Loader';
import React from 'react';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';

import '../assets/react-toolbox/theme.css';
import { JOURNEY_BUILDER_PATH } from '../Shared/Routing/routingPaths';
import CustomIntlProvider from '../Shared/CustomIntlProvider';
import GoogleAnalytics from './GoogleAnalytics';
import JourneyBuilderArea from '../JourneyBuilder';
import toolboxTheme from '../assets/react-toolbox/theme';

const styles = theme => ({
  '@global': {
    '*': {
      fontFamily: theme.typography.fontFamily,
      boxSizing: 'border-box',
    },
    html: {
      background: theme.palette.background.default,
      margin: 0,
      padding: 0,
      overflowX: 'hidden',
      maxWidth: 'calc(100vw)',
    },
    body: {
      margin: 0,
      padding: 0,
      overflowX: 'scroll',
      maxWidth: 'calc(100vw)',
    },
    a: {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
  },
});

export const Root = ({ store, isAppDataLoaded, userConfirmationHandler, classes }) => {
  // We don't have app data (window.App); likely because we're running the UI
  // via node on dev box. Display Loader while data is being fetched.
  if (!isAppDataLoaded) {
    return <Loader />;
  }

  // We have window.App OR it could not be loaded (api isn't running); do a normal render
  return (
    <ThemeProvider theme={toolboxTheme}>
      <Provider store={store}>
        <CustomIntlProvider>
          <Router>
            <div className={classes.root}>
              <Switch>
                <Route
                  path={JOURNEY_BUILDER_PATH}
                  component={JourneyBuilderArea}
                  breadcrumb="JourneyBuilder"
                />
              </Switch>
              <Route component={GoogleAnalytics} />
            </div>
          </Router>
        </CustomIntlProvider>
      </Provider>
    </ThemeProvider>
  );
};

Root.displayName = 'Root';

export default withStyles(styles, { name: 'Root' })(Root);



// WEBPACK FOOTER //
// ./src/Root/Root.js